import Vue from 'vue';
export default Vue.extend({
    props: {
        image: Object,
        default: null
    },
});
